import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useAtom } from 'jotai';
import { isDrawerOpen as isDrawerOpenAtom } from 'atoms/drawer';
import { CSSObject, styled, Theme, useTheme } from '@mui/material/styles';

import { drawerWidth } from 'utils/constants';
import FullScreenLoader from '../FullScreenLoader';
import Box from '@mui/material/Box';

const openedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  width: `calc(100% - ${drawerWidth}px)`,
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(100% - ${theme.spacing(8)})`,
});

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{ open?: boolean }>(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
    }),
  }),
);

const MainContent = () => {
  const [isDrawerOpen] = useAtom(isDrawerOpenAtom);

  const theme = useTheme();

  return (
    <Main open={isDrawerOpen} sx={{ mt: '64px' }}>
      <Box sx={{ p: 3, height: '100%' }}>
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Main>
  );
};

export default MainContent;
